import type { CompletedStandardOrder } from '@vista-digital/ocapi-types/v1'
import { getCompletedOrderById, getSiteById, loadCompletedOrderById } from '@vista-digital/occ-domain'

export const getConcessionCompletedOrderData = async (orderId: string) => {
    await loadCompletedOrderById(orderId)
    const completedFnbOrder = getCompletedOrderById(orderId) as CompletedStandardOrder | undefined

    const site = getSiteById(completedFnbOrder?.siteId || '')
    const items = completedFnbOrder?.items || []

    if (!completedFnbOrder) return {}
    return {
        items: items,
        site,
        value: completedFnbOrder.totalPrice.valueIncludingTax,
        transactionId: completedFnbOrder.id,
        vistaTransactionId: completedFnbOrder.transaction?.number,
    }
}
